import { ALL_WEBSITES } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case ALL_WEBSITES:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
